import React from "react";
import { render } from "react-dom";

import Search from "./components/Search";

const search = document.getElementById("search");
if (search != null) {
    const customOptions = typeof search.dataset.customOptions !== "undefined" ? JSON.parse(search.dataset.customOptions) : "";

    render(
        <Search
            searchResultsUrl={search.dataset.searchResultsUrl}
            vehicleSearchUrl={search.dataset.vehicleSearchUrl}
            query={search.dataset.query}
            placeholderUrl={search.dataset.placeholderUrl}
            customOptions={customOptions}
        />,
        search
    );
}
